<template>
  <div v-if="currentVGame === 'VSoccer'" class="a-vs-b-countdown">
    <p>{{$t('round')}} {{roundNo % 1000}} {{$t('starts_in').toLowerCase()}}:</p>
    <div ref="timerObjectContainerSoccer" class="a-vs-b--cd-progress-bar">
      <object id="VsoccerProgressObject" ref="timerObjectSoccer" :width="progressValue" style="{'background-size': 0px 10px}" alt="coundown-timer"></object>
    </div>
    <span>{{timerValue | timeFormat}}</span>
  </div>
  <div v-else-if="currentVGame === 'GrayhoundRaces'" class="a-vg-c--countdown">
    <div class="label"><p>{{$t('vdog_next')}} {{$t('round')}} {{roundNo % 1000}} {{$t('starts_in').toLowerCase()}}:</p></div>
    <div ref="timerObjectContainerDogs" class="a-vg-c--cd-progress-bar">
      <object id="GrayhoundProgressObject" ref="timerObjectDogs" :width="progressValue" style="{'background-size': 0px 10px}" alt="coundown-timer"></object>
    </div>
    <div class="seconds">
      <span>{{timerValue | timeFormat}}</span>
    </div>
  </div>
</template>

<script>
import { eventBus } from '../../main.js'
import EventConstants from '../../constants/Events'

export default {
  props: {
    'eventForTick': {
      type: String,
      default: 'default_timer_tick'
    },
    'roundLength': {
      type: Number,
      default: 180
    },
    roundNo: {
      type: Number,
      required: false
    },
    currentVGame: {
      type: String,
      required: true
    },
    isDisplayed: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      'timerValue': 0,
      'matchFinishAt': 0,
      'interval': null,
      counter: 0
    }
  },
  destroyed () {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
    window.removeEventListener('resize', this.handleResize)
    // eventBus.$off(EventConstants.CHANGE_GAME_ACTION, this.handleResizeSoccer)
  },
  created: function () {
    window.addEventListener('resize', this.handleResize)
    eventBus.$on(this.eventForTick + '_timer', this.eventSecoundToStart)
    eventBus.$on(EventConstants.CHANGE_GAME_ACTION, this.handleResize)
    eventBus.$on(EventConstants.LOADING_COMPLETE, this.handleResize)

    this.handleResize()
    this.runTimer()
  },
  beforeDestroy () {
    eventBus.$off(this.eventForTick + '_timer', this.eventSecoundToStart)
    eventBus.$off(EventConstants.CHANGE_GAME_ACTION, this.handleResize)
    eventBus.$off(EventConstants.LOADING_COMPLETE, this.handleResize)
  },
  methods: {
    eventSecoundToStart (val) {
      this.timerValue = val
      this.matchFinishAt = this.timerValue * 1000 + (new Date().getTime())
      this.runTimer()
    },
    handleResize () {
      setTimeout(() => {
        if (this.$refs.timerObjectSoccer && this.$refs.timerObjectContainerSoccer) {
          this.$refs.timerObjectSoccer.style.backgroundSize = `${this.$refs.timerObjectContainerSoccer.clientWidth}px 10px`
          if (this.$refs.timerObjectContainerSoccer.clientWidth < 100) {
            if (this.counter < 10) {
              ++this.counter
              setTimeout(() => { this.handleResize() }, 20)
            } else {
              setTimeout(() => { this.counter = 0 }, 100)
            }
          }
        }
        if (this.$refs.timerObjectDogs && this.$refs.timerObjectContainerDogs) {
          this.$refs.timerObjectDogs.style.backgroundSize = `${this.$refs.timerObjectContainerDogs.clientWidth}px 10px`
          if (this.$refs.timerObjectContainerDogs.clientWidth < 100) {
            if (this.counter < 10) {
              ++this.counter
              setTimeout(() => { this.handleResize() }, 20)
            } else {
              setTimeout(() => { this.counter = 0 }, 100)
            }
          }
        }
      })
    },
    clearTimer: function () {
      if (this.interval) {
        clearInterval(this.interval)
        this.interval = null
      }
    },
    runTimer: function () {
      if (this.interval) {
        this.clearTimer()
      }
      this.interval = setInterval(() => {
        if (this.timerValue <= 0) {
          this.clearTimer()
          return
        }
        let secToStart = (this.matchFinishAt - new Date().getTime()) / 1000
        let currentTime = secToStart < 0 ? 0 : secToStart
        Math.abs(currentTime - this.timerValue)
        if (Math.abs(currentTime - this.timerValue) > 2) {
          this.timerValue = currentTime
        } else {
          this.timerValue--
        }
        eventBus.customEvent(this.eventForTick, this.timerValue)
      }, 1000)
    }
  },
  filters: {
    timeFormat: function (secNum) {
      var hours = Math.floor(secNum / 3600)
      var minutes = Math.floor((secNum - (hours * 3600)) / 60)
      var seconds = Math.floor(secNum - (hours * 3600) - (minutes * 60))
      if (minutes < 10) { minutes = '0' + minutes }
      if (seconds < 10) { seconds = '0' + seconds }
      return minutes + ':' + seconds
    }
  },
  computed: {
    progressValue: function () {
      return (((100 * this.timerValue) / this.roundLength) || 0) + '%'
    }
  },
  watch: {
    isDisplayed: function (isDisplayed) {
      if (isDisplayed) {
        this.handleResize()
      }
    }
  }
}
</script>
